// Import images
import service1 from '../../Assets/images/services/service-1.jpg';
import service2 from '../../Assets/images/services/service-2.jpg';
import service3 from '../../Assets/images/services/service-3.jpg';
import service4 from '../../Assets/images/services/service-4.jpg';
import service5 from '../../Assets/images/services/service-5.jpg';
import service6 from '../../Assets/images/services/service-6.jpg';
import service7 from '../../Assets/images/services/service-7.jpg';
import service8 from '../../Assets/images/services/service-8.jpg';
import service9 from '../../Assets/images/services/service-9.jpg';
import service10 from '../../Assets/images/services/service-10.jpg';

const servicesData ={
    deatils:`Our network of 380 directly and indirectly employed, skilled professionals ensures we provide a consistent level of excellent service. Training and development are keys to our success and we ensure all our employees are provided with regular training in areas such as new technology, health and safety and customer service.
    We also ensure all our employees have the opportunity to develop their careers with the business, as well as attracting some of the brightest and best talent from elsewhere.
    We provide a 360-degree scope on civil and MEP contracting, maintenance and
    corporate Real-estate`,
    mainImage:service1,
    mainImageWebp:service1,
    typeOfService:[
    {
        id:1,
        name:'Construction',
        pathName:'Construction',
        imagePath:service1,
        imageAlt: 'service Construction',
        deatils: `Through our general contracting service, and with the vast years of experience in the field, we identify the means and methods.
        Necessary for the comprehensive execution of the project along with the services
        required in accordance with the contract documents provided by the client.
        We undertake various types of construction projects such as buildings, residential
        villas, schools, universities, mosques and factories.`,
        types:['Civil Work','Renovation','Smart Services','Landscape','Swimming pool','Interior','Exterior','Flooring'],
    },
    
    {
        id:2,
        name:'Civil Work',
        pathName:'civil-Work',
        imagePath:service2,
        imageAlt: 'service Civil-Work',
        deatils: `Mac Line civil work devision provides high-quality Civil work & Repair systems. Our services increase the strength and functionality of concrete structures for longer.`,
        types:['Substructure','Superstructure','Plastering','Screeding','Blocks','Tiles','Paint'],
     
    },
    {
        id:3,
        name:'MEP',
        pathName:'MEP',
        imagePath: service3,
        imageAlt: 'service MEP',
        deatils: `One of the best in leading in lasting, environmentally-friendly MEP solutions in the UAE.
        From air-conditioning, electrical installations, fire protection systems to plumbing!
        We have the expertise cutting edge technology and manpower.`,
        types:['Electrical','Plumping','Fire Protection','HAVAC'],
    },
    {
        id:4,
        name:'Renovation',
        pathName:'Renovation',
        imagePath: service4,
        imageAlt: 'service Renovation',
        deatils: `Our renovation services vary from commercial and residential spaces such as apartment renovation, villa renovation, once renovation, hospital renovation, hotel renovation, studio renovation, any indoor renovation (bathroom renovation, kitchen renovation), etc.
        Our goal is to create modern renovated designs that truly reflect our company values which is providing excellent and top quality renovation designs and services while ensuring client preferences are met and further excelling to their needs. We aim to achieve great excellence and with our drive for quality servicing and with our expert renovation professionals, Mac Line properties & contracting LLC is one of the leading renovation service providing companies in Abu Dhabi.
        `,
        types:['Maintenance','Building Renovation','Villa Renovation','Shops Renovation',
                'Authority Approvals','Joinery & Furniture','Offices Renovation','Interior Design','Home Renovation','Bathroom Renovation','Refurbishment'],
    },
    {
        id:5,
        name:'Smart Services',
        pathName:'Smart-Services',
        imagePath: service5,
        imageAlt: 'Smart-Services',
        deatils: ``,
        types:[null],
    },
    {
        id:6,
        name:'Landscape',
        pathName:'Landscape',
        imagePath: service6,
        imageAlt: 'service Landscape',
        deatils: `Our ambition : is to create beautiful and functional outside spaces of the highest quality, that deliver atmosphere and strength of form in abundance Whether designing a country garden or a tiny urban rooftop crying out for greening.
        Our aim : is to oer a real sense of connection, mind, body, and soul to the Landscape. Simplicity, distillation, and attention to detail are guiding principles, and the results are unmatchable outdoor spaces.
        Our Promise : Only Mac Line Landscape devision oers unmatched realism built on a technology platform that ensures quality products from the ground up which comes with up to 10 Years of Warranty. Mac Line Landscape devision commits to honesty and integrity and a desire to make our customers glad in around UAE.
        `,
        types:['Irrigation System','Pergola Design & Construction','Gazebo Design & Construction','Garden','Commercial','BBQ Design & Construction','Villa','Residental'],
    },
    {
        id:7,
        name:'Swimming pool',
        pathName:'Swimming-Pool',
        imagePath: service7,
        imageAlt: 'service Swimming-pool',
        deatils: `A swimming pool provides the ultimate leisure experience, and is the ultimate statement of luxury. In addition to being very aesthetically pleasing, the proper use of swimming pools can also provide a large number of health benets, such as better cardiovascular health, muscle strength and maintaining a healthy weight , It can also be a great place to have fun and socialise! Mac Line Swimming Pool devision specialise in providing exceptional design, construction and maintenance services for swimming pools and water features. With our years of local experience, you can rest assured that your poolscape works are in the best hands.`,
        types:['Outdoor Pool','Indoor Pool','Underwater Window','Pool Covers','Wave Pool','Maintenance'],
    },
    {
        id:8,
        name:'Interior',
        pathName:'Interior',
        imagePath: service8,
        imageAlt: 'service Interior',
        deatils: `Are you looking for an interior design company for your project ?
        Mac Line interior devision is providing turnkey interior design services for Residential and Commercial Projects in UAE. Our Interior Design devision has built up a blue-chip reputation based upon reliability ,consistency of delivery and value for our client. We are specialized in high-end luxury interior design services to companies and individual clients in the United Arab Emirates. Our success determines our exclusivity, quality of services, and a responsible approach to the work of our entire team of like-minded people who share our values. We oer realistic 3D interior design, AutoCAD details drawings and project management as our full package. At Mac Line Interiors devision , we design exclusive interiors for Home, Office, Hotel, Restaurant and Retail projects.`,
        types:[null],
    },
    {
        id:9,
        name:'Exterior',
        pathName:'Exterior',
        imagePath: service9,
        imageAlt: 'service Exterior',
        deatils: `Our understanding of the need for designing is very clear. We know that each client approaching us is seeking something exclusive & marvelous.
        We have the complete assurance to all our clients that each project developed by us will be one of a kind.
        Our project exterior design services will ensure the development of the pace keeping the personal choice & optimum functionality in consideration.
        We completely understand that each client will have distinctive requirements & preferences; our entire designing process has been developed to create output keeping this aspect in mind.`,
        types:['Paint','Doors','Façade','GRC','Cladding','Roofing','Red Clay','Cape Reed'],
    },
    {
        id:10,
        name:'Flooring',
        pathName:'Flooring',
        imagePath: service10,
        imageAlt: 'service Flooring',
        deatils: `Keep your floors up-to-date,vibrant and elegant with our premium products with the latest trends and top quality services.
        Mac Line flooring devision helping you by providing unique flooring ideas that will provide you with utmost satisfaction.
        Our products are guranteed to fulfil your expectations to the fullest and quality is never compromised.
        Mac Line flooring devision specialise in providing complete residential, office hospitality, school & hospital and sports ooring solutions that can be tailored to match your requirements`,
        types:['Epoxy Paint','Grinding & Crystalling','Polishing','Tile & Grouting','Waterproofing'],
    },
    {
        id:11,
        name:'Facilities Management',
        pathName:'Facilities-Management',
        imagePath: null,
        imageAlt: '',
        deatils: `We deliver customer centric facilities management solutions through State of the-art technology, highly trained professionals, local best practices and transparent operations for the sustained long term benefit for all stakeholders.
        These services are provided Across several sectors including all types of private and governmental Offices, Hospitality, Banking, Retail, Shopping Malls, Villas Residential Flats and Apartments.`,
        types:['Real Estate Management','Cleaning Housekeeping','Water Tank Cleaning Service','Pest Control Service','Building Maintenance','Disinfection Service','Security Service','CCTV'],
    },
    
]}


export default servicesData;